import React from "react";
import Image from "next/image";
import {
  AspectRatio,
  Box,
  Heading,
  ListItem,
  Stack,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import {HEADING_VARIANTS} from "@/theme/components/heading";
import {TEXT_VARIANTS} from "@/theme/components/text";

type Props = {
  content: string[];
  heading: string[];
  image?: React.ReactElement | string;
  list?: string[];
  subHeading?: string;
};

const IntroLayout = (props: Props) => {
  const {content, heading, image, list = [], subHeading} = props;
  return (
    <Stack
      alignItems={{base: "stretch", sm: "center", md: "start"}}
      direction={{base: "column", md: "row"}}
      spacing={{base: 6, md: 12}}
    >
      <Stack flex={1} spacing={4}>
        <Stack spacing={4}>
          {subHeading && (
            <Box>
              <Text color={"brand.100"} fontWeight={700} variant={TEXT_VARIANTS.BODY1}>
                {subHeading}
              </Text>
            </Box>
          )}
          {heading && (
            <Box>
              {heading.map((eachHeading, index) => (
                <Heading
                  key={index}
                  variant={{
                    base: HEADING_VARIANTS.SUBTITLE1,
                    md: HEADING_VARIANTS.HEADLINE3,
                  }}
                >
                  {eachHeading}
                </Heading>
              ))}
            </Box>
          )}
        </Stack>
        {content && (
          <Stack>
            {content.map((eachContent, index) => (
              <Text key={index} variant={TEXT_VARIANTS.BODY1}>
                {eachContent}
              </Text>
            ))}
          </Stack>
        )}

        {list && (
          <UnorderedList spacing={2}>
            {list?.map((eachListItem, index) => {
              return (
                <ListItem key={index}>
                  <Text variant={TEXT_VARIANTS.BODY1}>{eachListItem}</Text>
                </ListItem>
              );
            })}
          </UnorderedList>
        )}
      </Stack>
      {typeof image === "string" ? (
        <AspectRatio
          position={"relative"}
          ratio={10 / 8}
          width={{base: "full", sm: "300px", md: "400px", lg: "450px"}}
        >
          <Image
            alt=""
            src={image}
            fill
            style={{objectFit: "contain", objectPosition: "top"}}
          />
        </AspectRatio>
      ) : (
        <Box>{image}</Box>
      )}
    </Stack>
  );
};

export default IntroLayout;
